import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../reducers'
import { getUIConfigAction, setUIConfigAction } from '../../../actions/admin/adminTerminals'
import { UiConfig } from '../../../types/uiConfig'
import './locationsSettings.less'

const mapStateToProps = (state: AppState) => ({
  uiConfig: state.adminTerminals.uiConfig,
  pairs: state.adminTerminals.pairs,
})

const mapDispatchToProps = {
  getUIConfig: getUIConfigAction,
  setUIConfig: setUIConfigAction,
}
type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

type SettingName = 'allowCheckIn' | 'separateCoupon' | 'autoAddingAddons' | 'denyOvernight' | 'allowEl' | 'allowIMO'

interface PortShipSettings {
  port: string
  ship: string
  allowCheckIn: boolean
  separateCoupon: boolean
  autoAddingAddons: boolean
  denyOvernight: boolean
  allowEl: boolean
  allowIMO: boolean
}

const LocationsSettings: React.FC<Props> = ({ uiConfig, getUIConfig, setUIConfig, pairs }: Props) => {
  const [totalList, setTotalList] = useState<PortShipSettings[]>()

  const buildTotalList = (data: UiConfig) => {
    const newTotalList: PortShipSettings[] = pairs.map((pair: string) => {
      const [port, ship] = pair.split(':')
      return {
        port,
        ship,
        allowCheckIn: data.allowCheckIn.includes(pair),
        separateCoupon: data.separateCoupon.includes(pair),
        autoAddingAddons: data.autoAddingAddons.includes(pair),
        denyOvernight: data.denyOvernight.includes(pair),
        allowEl: data.allowEl.includes(pair),
        allowIMO: data.allowIMO.includes(pair),
      }
    })
    setTotalList(newTotalList)
  }

  const preparePortAndShip = (fieldName: SettingName, newTotalList: PortShipSettings[]) => {
    return newTotalList.reduce(
      (acc: string[], item) => (item[fieldName] ? [...acc, `${item.port}:${item.ship}`] : acc),
      [],
    )
  }

  const onChangeCheckbox = (index: number, fieldName: SettingName) => {
    if (!totalList) {
      return null
    }
    const newTotalList = [...totalList]
    newTotalList[index][fieldName] = !newTotalList[index][fieldName]
    setUIConfig({
      ...uiConfig,
      allowCheckIn: preparePortAndShip('allowCheckIn', newTotalList),
      separateCoupon: preparePortAndShip('separateCoupon', newTotalList),
      autoAddingAddons: preparePortAndShip('autoAddingAddons', newTotalList),
      denyOvernight: preparePortAndShip('denyOvernight', newTotalList),
      allowEl: preparePortAndShip('allowEl', newTotalList),
      allowIMO: preparePortAndShip('allowIMO', newTotalList),
    })
  }

  useEffect(() => {
    getUIConfig()
  }, [getUIConfig])

  useEffect(() => {
    uiConfig && buildTotalList(uiConfig)
  }, [uiConfig])

  if (!totalList) {
    return null
  }
  return (
    <div className="locations-settings-block">
      <div className="table-header row">
        <div className="cell column-port">
          <strong>Port</strong>
        </div>
        <div className="cell column-ship">
          <strong>Ship</strong>
        </div>
        <div className="cell column-allowCheckIn">
          <strong>Allow self check-in</strong>
        </div>
        <div className="cell column-separateCoupon">
          <strong>Print separate vehicle ticket</strong>
        </div>
        <div className="cell column-additionalAddons">
          <strong>Addons to be added</strong>
        </div>
        <div className="cell column-denyOvernight">
          <strong>Deny overnight</strong>
        </div>
        <div className="cell column-allowEl">
          <strong>Allow Electrical Supply</strong>
        </div>
        <div className="cell column-allowIMO">
          <strong>Allow Dangerous Goods</strong>
        </div>
        <div className="space-for-scrollbar"></div>
      </div>
      <div className="table">
        {totalList.map((item: PortShipSettings, index: number) => (
          <div key={index} className="row">
            <div className="cell column-port border-right">{item.port}</div>
            <div className="cell column-ship border-right">{item.ship}</div>
            <div className="cell column-allowCheckIn border-right">
              <input
                type="checkbox"
                checked={item.allowCheckIn}
                onChange={() => onChangeCheckbox(index, 'allowCheckIn')}
              />
            </div>
            <div className="cell column-separateCoupon border-right">
              <input
                type="checkbox"
                checked={item.separateCoupon}
                onChange={() => onChangeCheckbox(index, 'separateCoupon')}
              />
            </div>
            <div className="cell column-additionalAddons border-right">
              <input
                type="checkbox"
                checked={item.autoAddingAddons}
                onChange={() => onChangeCheckbox(index, 'autoAddingAddons')}
              />
            </div>
            <div className="cell column-denyOvernight border-right">
              <input
                type="checkbox"
                checked={item.denyOvernight}
                onChange={() => onChangeCheckbox(index, 'denyOvernight')}
              />
            </div>
            <div className="cell column-allowEl border-right">
              <input type="checkbox" checked={item.allowEl} onChange={() => onChangeCheckbox(index, 'allowEl')} />
            </div>
            <div className="cell column-allowIMO">
              <input type="checkbox" checked={item.allowIMO} onChange={() => onChangeCheckbox(index, 'allowIMO')} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationsSettings)
